import Swiper from "swiper/swiper-bundle";

export default{ 
  init() {
    var Testimonial = new Swiper('.testimonial', {
      effect: 'fade',
      loop: true,
      autoHeight: true,
      pagination: {
        el: '.testimonial__pagination',
        clickable: true,
      }
    });

    var swiper = new Swiper('.swiper-container', {
      loop: true,
      navigation: {
        nextEl: '.vdo.swiper-button-next',
        prevEl: '.vdo.swiper-button-prev',
        clickable: true,
      },
    });
  },
  finalize() {},
};
